export const SpecificCustomerEnum = Object.freeze({
  AIRFRANCE: "1279",
  AUBADE: "1413",
  BALIBARIS: "805",
  FATHER_SONS: "1203",
  HAST_PARIS: "1036",
  HINDBAG: "852",
  LA_BELLLE_BOUCLE: "1174",
  LA_ROSEE: "1296",
  ORAIJE: "1465",
  PASSAGE_DU_DESIR: "1406",
  PAYOT: "1129",
  SALES_DEMO: "497",
  SAMSUNG: "1040",
  SIMIO: "1",
  TRANSAVIA: "1419",

  DevelopmentMain: "1",

  DorianDevCats: "1167",
  EmmanuelleDevSimio: "480",
});
